module.exports = __webpack_public_path__ + "img/office-folder-1.cdabd15f.svg";